import { createStyles, makeStyles } from '@hawkins/styles';
export function skeletonLoaderStyles(theme) {
    var hawkins = theme.hawkins, hawkinsVariables = theme.hawkinsVariables;
    return createStyles({
        '@keyframes shimmer': {
            '0%': { backgroundColor: hawkins.ui.backgroundColor4 },
            '100%': { backgroundColor: hawkins.ui.backgroundColor3 },
        },
        '@media (prefers-reduced-motion: no-preference)': {
            root: { animation: '$shimmer 1.4s ease-in-out alternate infinite' },
        },
        /** Class name of the root element. */
        root: {
            backgroundColor: hawkins.ui.backgroundColor3,
            // In case the consumer sets a width that's wider than the component's container.
            maxWidth: '100%',
        },
        /** Class name of the root element in the circle variant. */
        rootCircle: {
            borderRadius: '50%',
        },
        /** Class name of the root element in the square variant. */
        rootSquare: {
            borderRadius: hawkinsVariables.borderRadius.borderRadius0,
        },
        /** Class name of the root element in the text variant. */
        rootText: {
            borderRadius: 100,
        },
    });
}
export var useSkeletonLoaderStyles = makeStyles(skeletonLoaderStyles, { name: 'Hawkins-SkeletonLoader' });
